import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-cart-header',
    templateUrl: './cart-header.shared.component.html',
    styleUrls: ['./cart-header.shared.component.scss']
})
export class CartHeaderComponent implements OnInit {
    @Input() public pickupTimeLabel: string = '';
    @Input() public totalPrefix: string = 'Your order summary total ';
    @Input() public total: number = 0;
    @Input() public btnWidth: OLO.Components.BUTTON_WIDTH = 'extended';
    @Input() public btnSize: OLO.Components.BUTTON_SIZE = 'lg';
    @Input() public btnFeelOrderMore: OLO.Components.BUTTON_FEEL = 'secondary';
    @Input() public btnFeelCheckout: OLO.Components.BUTTON_FEEL = 'primary';
    @Input() public btnInvertedOrderMore: boolean = true;
    @Input() public btnInvertedCheckout: boolean = true;
    @Input() public labelOrderMore: string = 'Order more';
    @Input() public labelCheckout: string = 'Checkout';
    @Input() public headerSubInverted: boolean = false;
    @Input() public headerMainInverted: boolean = true;

    @Output() public onOrderMoreClick: EventEmitter<Event> = new EventEmitter();
    @Output() public onCheckoutClick: EventEmitter<Event> = new EventEmitter();

    public loadingAfterCheckout: boolean;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void { }

    public handleOrderMoreClick($event: Event): void {
        this.onOrderMoreClick.emit($event);
    }

    public handleCheckoutClick($event: Event): void {
        this.loadingAfterCheckout = true;
        this.onCheckoutClick.emit($event);
    }
}
